import FileSaver from "file-saver";
import React from "react";
import NotificationSystem from "react-notification-system";
import { Card, CardBody, CardHeader, Col, Row, Button } from "reactstrap";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";

class StudentFileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      fileName: "",
      file: {},
    };
  }

  componentDidMount() {}

  downloadFile = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "student/getRecords",
        method: "GET",
      });
      if (response) {
        this.setState({ showLoader: false });
        let csvData = response.records.map((e) => e.join(",")).join("\n");
        let data = new Blob([csvData], { type: "data:text/csv;charset=utf-8" });
        FileSaver.saveAs(data, "Students.csv");
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleChange = async (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      fileName: fileUploaded.name,
    });
    event.target.value = "";
  };

  handleUpload = async () => {
    if (!this.state.fileName) {
      this.notificationSystem.addNotification({
        message: "Select the file",
        level: "error",
      });
      return;
    }
    let formData = new FormData();
    formData.append("file", this.state.file);
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: `/student/uploadIds`,
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false, file: {}, fileName: "" });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false, file: {}, fileName: "" });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Student File Upload"
          breadcrumbs={[{ name: "Student File Upload", active: true }]}
        >
          <Row>
            <Col>
              <Card className="mb-12" style={{ marginBottom: "20px" }}>
                <CardHeader>
                  <h5 style={{ margin: "auto" }}>
                    Upload Student Excel File :
                  </h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md={6} style={{ margin: "0px", display: "flex" }}>
                      <label htmlFor="file">
                        <span className="btn btn-secondary">Select File</span>
                        <span style={{ marginLeft: "5px" }}>
                          {this.state.fileName}
                        </span>
                      </label>
                      <input
                        style={{ display: "none" }}
                        id="file"
                        type="file"
                        accept=".csv"
                        onChange={this.handleChange}
                      />
                    </Col>
                    <Col md={6}>
                      <Button onClick={this.handleUpload}>
                        Upload the file
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card className="mb-12" style={{ marginBottom: "20px" }}>
                <CardHeader>
                  <h5 style={{ margin: "auto" }}>
                    Download Student Excel File :
                  </h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md={6} style={{ margin: "0px", display: "flex" }}>
                      <Button onClick={this.downloadFile}>Download file</Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default StudentFileUpload;
